<app-si-dialog header="Account Credit Balance" [hideSaveButton]="true">
    <ng-template appDialogBody>
        <div class="my-4 text-center renew-text">
            Account shared credits next renew {{ accountRenewDate | date: 'MM/dd/yyyy'}}.
            <span *ngIf="hasLicenceCredits && licenseRenewDate">
            License credits next renew {{ licenseRenewDate | date: 'MM/dd/yyyy'}}
        </span>
        </div>

        <div class="flex flex-col h-full rounded overflow-hidden">
            <app-data-table
                [columns]="columns"
                [data]="tableData"
                [layoutFixed]="false"
            ></app-data-table>
        </div>
    </ng-template>
</app-si-dialog>
